import { render } from "./Changelog.vue?vue&type=template&id=b46a0a4e&ts=true"
import script from "./Changelog.vue?vue&type=script&lang=ts"
export * from "./Changelog.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/matthias/Code/uniki/vergabe/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__